import React from "react";
import { Navigate } from "react-router-dom";

interface Usuario {
  UsuarioID: number;
  Email: string;
  roles: string[];
}

interface Props {
  children: React.ReactNode;
}

const AdminRoute: React.FC<Props> = ({ children }) => {
  const user = localStorage.getItem("user");

  if (!user) {
    return <Navigate to="/admin-login" replace />;
  }

  let parsedUser: Usuario;

  try {
    parsedUser = JSON.parse(user);
  } catch {
    return <Navigate to="/admin-login" replace />;
  }

  if (!parsedUser.roles.includes("admin")) {
    return <Navigate to="/admin-login" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
